import us from '../../defines';
import {Point} from '../../lib/objects/';
import * as CONSTANTS from './constants';

export default function ConferenceMarker (viewport) {
  var jVpDiv = viewport.vpDivGet();
  var jConfMarker;

  var cpOffset = new Point(0, 0);

  // ............................................ move_local
  //    This function positions the conference marker offset from the current cursor
  //    or can hide the marker.  CoordSystem of marker is us.coordSystemNORM
  var move_ = function (xBase, yBase) {
    if (!jConfMarker) {
      return;
    }
    var cpLT = viewport.getViewLeftTop(us.coordSystemNORM);
    var zoom = viewport.getViewZoom();
    var x = Math.floor((xBase - cpLT.x) / zoom - cpOffset.x);
    var y = Math.floor((yBase - cpLT.y) / zoom - cpOffset.y);
    jConfMarker.css({
      display: 'block',
      left: x + 'px',
      top: y + 'px'
    });
  };
    // ............................................ load_() local
    //    This function loads the conference marker
  var load_ = function () {
    if (jConfMarker) return; // if this viewport already has a marker, return

    // first create an offscreen div that will contain the marker img and add it to the vp
    jConfMarker = $('<div/>', { // build the div tag that contains the img tag
      class: us.clsDIVMARKER, // dsc marker class sets its own z-index
      css: {
        display: 'none'
      }
    });
    jVpDiv.append(jConfMarker); // place the marker div in the vp

    cpOffset.x = Math.floor(jConfMarker.width() / 2); // define marker's offset from cursor
    cpOffset.y = Math.floor(jConfMarker.height() / 2);

    bindEvents_(); // add event handlers

    // ..................................................
    // closure functions
    // ............................................ bindEvents_()
    function bindEvents_ () {
      var namespace = viewport.eventNameSpaceGet();

      // show/hide conference marker of conference leader/follower
      $(us.idHashROOT).on(CONSTANTS.CONFERENCE_MARKER_EVENT + namespace, function (e, parms) {
        if (viewport.getImageId() == parms.imageId) { // move marker on the matching image
          move_(parms.MarkerX, parms.MarkerY);
        } else {
          // hide the marker on non-matching images
          jConfMarker.css({
            display: 'none'
          });
        }
      });
    }
  };

  load_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/conferencing/conferencing-marker.js